export const countriesGuideList = {
    'argentina': '7017R000001nHlxQAE',
    'colombia': '7017R000001nHlyQAE',
    'costa-rica': '7017R000001nHlzQAE',
    'ecuador': '7017R000001nHm0QAE',
    'brasil': '7017R000001nHm2QAE',
    'chile': '7017R000001nHm3QAE',
    'el-salvador': '7017R000001nHm7QAE',
    'panama': '7017R000001nHm8QAE',
    'guatemala': '7017R000001nHmCQAU',
    'nicaragua': '7017R000001nHmDQAU',
    'mexico': '7017R000001nHmHQAU',
    'peru': '7017R000001nHmMQAU',
    'paraguay': '7017R000001nHmWQAU',
    'uruguay': '7017R000001nHmXQAU',
};